// extracted by mini-css-extract-plugin
export default {"Button":"FacebookButton_Button__gxb0D"};